(() => {
  const loadImage = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.dataset.akDeferredSrc) return;

    if (image.dataset.akDeferredSrcset) image.srcset = image.dataset.akDeferredSrcset;
    image.src = image.dataset.akDeferredSrc;
    delete image.dataset.akDeferredSrc;
    delete image.dataset.akDeferredSrcset;
  };

  const images = Array.from(document.querySelectorAll('img[data-ak-deferred-src]'));
  if (!images.length) return;

  if (!('IntersectionObserver' in window)) {
    images.forEach(loadImage);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadImage(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '240px 160px' }
  );

  images.forEach((image) => observer.observe(image));
})();
